import MuiDialogTitle from "@mui/material/DialogTitle";
const DialogTitle = MuiDialogTitle;
export default DialogTitle;
